import { render, staticRenderFns } from "./PresentAsComponent.vue?vue&type=template&id=7eb22308&scoped=true"
import script from "./PresentAsComponent.vue?vue&type=script&lang=js"
export * from "./PresentAsComponent.vue?vue&type=script&lang=js"
import style0 from "./PresentAsComponent.vue?vue&type=style&index=0&id=7eb22308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb22308",
  null
  
)

export default component.exports